import type { Formular } from "@/api/materialSupplierService";
import { Box, Typography } from "@mui/material";

interface FormularProps {
  formular: Formular | null;
}

const FormularField = ({ formular }: FormularProps) => {
  return (
    <Box>
      <Box
        sx={{
          border: "1px solid rgba(0, 0, 0, 0.23)",
          borderRadius: "4px",
          padding: "16.5px 14px",
          minHeight: "120px",
          maxHeight: "300px",
          overflow: "auto",
          backgroundColor: "#fff",
          fontFamily: "monospace",
          fontSize: "14px",
          fontWeight: "bold",
          letterSpacing: "0.5px",
          lineHeight: "2",
          position: "relative",
        }}
      >
        <Box
          dangerouslySetInnerHTML={{
            __html: (() => {
              if (!formular) return "";

              return formular.formula
                .split("")
                .map((char) => {
                  switch (char) {
                    case "+":
                      return '<span style="color: #e91e63; font-weight: bold; font-size: 16px;">+</span>';
                    case "-":
                      return '<span style="color: #ff9800; font-weight: bold; font-size: 16px;">-</span>';
                    case "*":
                      return '<span style="color: #4caf50; font-weight: bold; font-size: 16px;">*</span>';
                    case "/":
                      return '<span style="color: #f44336; font-weight: bold; font-size: 16px;">/</span>';
                    case "(":
                      return '<span style="color: #2196f3; font-weight: bold; font-size: 16px;">(</span>';
                    case ")":
                      return '<span style="color: #2196f3; font-weight: bold; font-size: 16px;">)</span>';
                    default:
                      return char;
                  }
                })
                .join("");
            })(),
          }}
        />
      </Box>
      <Box display="flex" justifyContent="flex-end" mt={0.5}>
        <Typography variant="caption" color="textSecondary">
          Material Price (THB / KG)
        </Typography>
      </Box>
    </Box>
  );
};

export default FormularField;
